import { IOption } from '@vtbhome/juicyfront/types';

export const selectedOrderId = (fieldValue?: IOption[]) => {
    if (!fieldValue || !fieldValue.length) {
        return;
    }
    return Number(fieldValue[0].value);
};
